const cache = new Map<string, string>();
const inflight = new Map<string, Promise<string>>();

export function getCachedUrl(contentHash: string): string | undefined {
  return cache.get(contentHash);
}

export async function cacheImage(
  contentHash: string,
  sasUrl: string
): Promise<string> {
  const existing = cache.get(contentHash);
  if (existing) return existing;

  const pending = inflight.get(contentHash);
  if (pending) return pending;

  const promise = (async () => {
    const response = await fetch(sasUrl);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch image: ${response.status} ${response.statusText}`
      );
    }
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    cache.set(contentHash, url);
    return url;
  })();

  inflight.set(contentHash, promise);
  promise.finally(() => inflight.delete(contentHash));

  return promise;
}
